<template>
  <v-dialog 
  :value="value" 
  max-width="720"
  @input="$emit('input')">
    <v-card class="pb-2">
      <v-card-title>
        <span class="headline">Campaign Lists for @{{handle}}</span>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-data-table
              :headers="headers"
              :items="items"
              :items-per-page="10"
              :no-data-text="'Empty list'"
              class="elevation-1"              
              :key="dataTableKey"
            >
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="secondary"
          @click="close()"
        >
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: 'CampaignListsModal',
  props: [
    'items',
    'value',
    'handle'
  ],
  data() {
    return {
      headers: [
        {
          text: 'Campaign Name',
          value: 'name'
        },
        {
          text: 'Campaign Type',
          value: 'campaignType'
        },
        {
          text: 'Campaign Verticals',
          value: 'showVerticals'
        }
      ],
      dataTableKey: 1
    }
  },
  methods: {
    close() {
      this.$emit('input')
    }
  }
}
</script>



// WEBPACK FOOTER //
// CampaignListsModal.vue?33bacf42